import Fab from "@material-ui/core/Fab";
import React, { useEffect } from "react";
import ConnectionSignalOff32 from "@carbon/icons-react/lib/connection-signal--off/32";
import classNames from "classnames";
import Zoom from "@material-ui/core/Zoom";
import { useLocation, useParams } from "react-router-dom";
import { useTheme } from "@material-ui/core";
import useOnlineStatus from "@rehooks/online-status";
import offlineIndicatorStyles from "../styles/OfflineIndicator.styles";
import { useAppContext } from "../../../state/app/context";
import { GameRoutes } from "../../../routes/game-routes";

const OfflineIndicator = () => {
	const onlineStatus = useOnlineStatus();
	const classes = offlineIndicatorStyles();
	const theme = useTheme();
	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};
	const { pathname } = useLocation();
	const { eventId } = useParams();
	const isGameMode =
		!!eventId &&
		pathname.includes(GameRoutes.GAME_MODE.url.replace(":eventId", eventId));

	const { goOnline } = useAppContext();

	useEffect(() => {
		goOnline(onlineStatus);
	}, [onlineStatus]);

	return (
		<Zoom
			in={!isGameMode && !onlineStatus}
			timeout={transitionDuration}
			style={{
				transitionDelay: `${onlineStatus ? transitionDuration.exit : 0}ms`
			}}
			unmountOnExit
		>
			<Fab
				aria-label="Offline"
				className={classNames(classes.fab, classes.fabPrimary)}
				color="inherit"
			>
				<ConnectionSignalOff32 />
			</Fab>
		</Zoom>
	);
};

export default OfflineIndicator;
